<app-header (headerHeight)="getHeight($event)" (headerHeight1)="getHeight1($event)"></app-header>
<div class="flex flex-col flex-auto" style="min-height: 36rem;" [ngStyle]="{'margin-top': padding+'px' }">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-whastapp-button></app-whastapp-button>